import { gql, useLazyQuery } from '@apollo/client';
import { ISignatureRequest, SIGNATURE_REQUEST_FIELDS } from './useSignatureRequestCreateMutation';

const GET_SIGNATURE_REQUEST = gql`
  ${SIGNATURE_REQUEST_FIELDS}
  query GetSignatureRequest($token: String!) {
    getSignatureRequest(token: $token) {
      ...SignatureRequestFields
    }
  }
`;

export interface GetSignatureRequestInput {
  token: string;
}

export interface GetSignatureRequestResult {
  getSignatureRequest: ISignatureRequest;
}

export function useSignatureRequestQuery() {
  return useLazyQuery<GetSignatureRequestResult, GetSignatureRequestInput>(GET_SIGNATURE_REQUEST);
}
